export default class Arc {
  constructor(overlay, ctx, m = '') {
    this.ctx = ctx
    this.comp = overlay
    this.T = overlay.$props.config.TOOL_COLL
  }

  draw(p1, p2, p3) {
    const layout = this.comp.$props.layout

    let x1 = layout.t2screen(p1[0])
    let y1 = layout.$2screen(p1[1])
    let x2 = layout.t2screen(p2[0])
    let y2 = layout.$2screen(p2[1])
    let x3 = Math.abs(x2 - x1) / 2 + Math.min(x1, x2)
    let y3 = layout.$2screen(p3[1])

    let t = 0.5;
    let cpX = (x3 - (1 - t) * (1 - t) * x1 - t * t * x2) / (2 * t * (1 - t));
    let cpY = (y3 - (1 - t) * (1 - t) * y1 - t * t * y2) / (2 * t * (1 - t));

    this.ctx.moveTo(x1, y1)
    this.ctx.quadraticCurveTo(cpX, cpY, x2, y2);

    this.comp.collisions.push(this.make([x1, y1], [x2, y2], [x3, y3]))
  }

  // Collision function. x, y - mouse coord.
  make(p1, p2, p3, tolerance = 5) {
  // Compute control point
    const t = 0.5
    const cpX = (p3[0] - (1 - t) * (1 - t) * p1[0] - t * t * p2[0]) / (2 * t * (1 - t))
    const cpY = (p3[1] - (1 - t) * (1 - t) * p1[1] - t * t * p2[1]) / (2 * t * (1 - t))

    return (x, y) => {
      // Approximate curve by sampling points
      const steps = 200;
      for (let i = 0; i <= steps; i++) {
        const t = i / steps
        const bx = (1 - t) * (1 - t) * p1[0] + 2 * (1 - t) * t * cpX + t * t * p2[0]
        const by = (1 - t) * (1 - t) * p1[1] + 2 * (1 - t) * t * cpY + t * t * p2[1]
        const dx = x - bx
        const dy = y - by
        if (Math.sqrt(dx * dx + dy * dy) <= tolerance) return true
      }
      return false
    }
  }
}
